import { Component } from "@angular/core";

@Component({
    selector : "gfx-errors",
    templateUrl : "gfx.errors.component.html"
})
export class GfxErrorsComponent {
    title = "Liste des erreurs";
}